import React, { useEffect, useState } from 'react';
import { landingSliderService } from 'api/services/landing';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';

export const useLandingCarousel = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselData, setCarouselData] = useState([]);
  const landingConfig = useSelector(
    selectMetadataKeyByRegion('landing_telmex_config'),
  );

  const getCarouselData = async () => {
    try {
      const { data: sliderResponse } = await landingSliderService();
      //   let sliderResponse = mockData;
      setCarouselData([...sliderResponse?.data,...sliderResponse?.data]);
      setIsLoading(false);
    } catch (error) {
      console.log('error landing slider', error);
      setShowCarousel(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (landingConfig?.carousel_config?.enable) return setShowCarousel(true);
    setIsLoading(false);
  }, []);

  useEffect(
    () => {
      if (!showCarousel || !isLoading) return;

      getCarouselData();
    },
    [showCarousel, isLoading],
  );

  return {
    showCarousel,
    isMediaLoading: isLoading,
    carouselData,
  };
};
